"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentUpdatePayload = void 0;
var SegmentUpdatePayload_1 = require("./SegmentUpdatePayload");
Object.defineProperty(exports, "SegmentUpdatePayload", { enumerable: true, get: function () { return SegmentUpdatePayload_1.SegmentUpdatePayload; } });
